const LAYERS = {
  EAGLE_EYE: 'eagle_eye_camera_feeds',
  AXON: 'axon_police_tracking',
};

/**
 * There appears to be a race condition when getSpatialLayers api response arrives after map and Hermes load,
 * overwriting the existing state. For EEN it resulted in loosing the checkbox in map controls while still
 * plotting the cameras. axon had the same issue, but would recover.
 * The function below merges existing state with the incoming for specified keys
 */
const KEY_TO_MATCH = [LAYERS.EAGLE_EYE, LAYERS.AXON];

export const getEnrichedDynamicLayers = (existingDSLs = [], incomingDSLs) => {
  const matchedExisitngDSLs = existingDSLs.filter(dsl =>
    KEY_TO_MATCH.includes(dsl.key),
  );
  return [...matchedExisitngDSLs, ...incomingDSLs];
};
